'use strict';

exports.__esModule = true;

var _ScriptTag = require('./ScriptTag');

var _ScriptTag2 = _interopRequireDefault(_ScriptTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ScriptTag2.default;